<template>
    <div class="collectionFrequencyUP">
        <div class="upgradeInfo">
            <div class="closepage" @click="clickClosepage"></div>
            <div class="xinxi">
                <span class="top-info">
                    <span v-if="collectionUPPage==1" class="name">{{ $t('collectionFrequencyUP.collect_recharge1') }}</span>
                    <span v-if="collectionUPPage==2" class="name">{{ $t('collectionFrequencyUP.collect_recharge') }}</span>
                </span>
            </div>
        </div>
        <div class="infobox"  v-loading="frequencyUPLoading">
            <div class="content">
                <div class="tab-bar">
                  <span
                   v-if="rechargeFlagObj && rechargeFlagObj.energyFlowEnabled"
                    :class="['tab-item', { active: collectionUPPage === 1 }]"
                    @click="switchTab(1)"
                  >{{$t('collectionFrequencyUP.collect_fast')}}</span>
                  <span
                   v-if="rechargeFlagObj && rechargeFlagObj.accelerateEnabled"
                    :class="['tab-item', { active: collectionUPPage === 2 }]"
                    @click="switchTab(2)"
                  >{{$t('collectionFrequencyUP.collect_fast1')}}</span>
                </div>
                <el-form ref="form" label-width="200px">
                    <el-form-item :label="$t('datalogger.datalogger_pn')" size="small">
                        <div>{{ deviceInfo.pn }}<span class="storageTips" v-if="collectionUPPage==1">（{{ $t('collectionFrequencyUP.collect_fasting_title') }}）</span></div>
                    </el-form-item>
                    <el-form-item :label="`${$t('collectionFrequencyUP.Package')}:`" size="small">
                        <!-- :class="{ selected: rechargingInfo.package && rechargingInfo.package.periodSeconds == item.periodSeconds, disabled: isPackageDisabled(item) }" -->
                        <!-- :class="{ selected: rechargingInfo.package && rechargingInfo.package.periodSeconds == item.periodSeconds && !(collectionUPPage == 1 && currentEnergyFetch == 5), disabled: isPackageDisabled(item) }" -->
                        <span
                            v-for="(item, index) in availablePackages"
                            :key="index"
                            class="package"
                            :class="{ selected: rechargingInfo.package && rechargingInfo.package.periodSeconds == item.periodSeconds, disabled: isPackageDisabled(item) }"
                            @click="!isPackageDisabled(item) && (rechargingInfo.package = item)"
                            :style="{pointerEvents: isPackageDisabled(item)?'none':'', opacity: isPackageDisabled(item)?'0.6':'1', cursor: isPackageDisabled(item)?'not-allowed':'pointer'}"
                          >
                          {{ item.periodDesc||item.period }}
                            <!-- {{ item.specName }} -->
                            <span v-if="isPackageDisabled(item)" class="line"></span>
                          </span>
                          <!-- cursor: not-allowed;
                          pointer-events: none; -->
                    </el-form-item>
                    <el-form-item label=" " size="small" v-if="rechargingInfo&&rechargingInfo.package">
                        <!-- <div class="packageTip" v-if="collectionUPPage ==2">{{$t('collectionFrequencyUP.every_interval')}}<span class="active">{{rechargingInfo?rechargingInfo.package.specValue:''}}</span>{{`min${$t('collectionFrequencyUP.gather')}`}}<span class="active">1</span>{{$t('collectionFrequencyUP.Once')}}</div>
                        <div class="packageTip" v-if="collectionUPPage ==1">{{$t('collectionFrequencyUP.every_interval')}}<span class="active">{{rechargingInfo?rechargingInfo.package.specValue:''}}</span>{{`s${$t('collectionFrequencyUP.gather')}`}}<span class="active">1</span>{{$t('collectionFrequencyUP.Once')}}</div> -->
                        <div class="packageTip">{{$t('collectionFrequencyUP.every_interval')}}<span class="active">{{rechargingInfo?rechargingInfo.package.periodSeconds+'s':''}}</span>{{`${$t('collectionFrequencyUP.gather')}`}}<span class="active">1</span>{{$t('collectionFrequencyUP.Once')}}</div>
                    </el-form-item>
                    <el-form-item :label="`${$t('rosRecharge.rechargeDuration')}:`" size="small" v-if="durationOptions.length">
                        <span
                            v-for="item in durationOptions"
                            :key="item.value"
                            class="package"
                            :class="{ selected: selectedDuration === item.value, disabled: isDurationDisabled(item) }"
                            @click="!isDurationDisabled(item) && (selectedDuration = item.value)"
                            :style="{pointerEvents: isDurationDisabled(item)?'none':'', opacity: isDurationDisabled(item)?'0.6':'1', cursor: isDurationDisabled(item)?'not-allowed':'pointer'}"
                        >
                            {{ item.label }}
                            <span v-if="isDurationDisabled(item)" class="line"></span>
                        </span>
                    </el-form-item>
                    <el-form-item :label="`${$t('collectionFrequencyUP.Payment_method')}:`" size="small">
                        <div style="display: flex; align-items: center;">
                            <div class="paymentMethodItem" 
                                 :class="{ disabled: wechatDisabled }" 
                                 :style="{ pointerEvents: wechatDisabled ? 'none' : '', opacity: wechatDisabled ? 0.6 : 1, cursor: wechatDisabled ? 'not-allowed' : 'pointer' }"
                                 @click="!wechatDisabled && PaymentMethodClick(0)">
                                <img src="../../../../assets/img/recharge/weixin.png" style="width: 70px;" alt="">
                                <div class="rightContent">
                                    <div class="weixinHeard">
                                        <span style="font-size: 16px;">{{ $t('recharge.Recharge_tip5') }}</span>
                                        <span class="paybaseShow" :class="{ payChoose: PaymentMethod == 0 }"></span>
                                    </div>
                                    <div class="weixinPayTip">
                                        {{ $t('recharge.Recharge_tip3') }}
                                    </div>
                                </div>
                            </div>
                            <div class="paymentMethodItem" 
                                 style="margin-left: 10px;" 
                                 :class="{ disabled: paypalDisabled }"
                                 :style="{ pointerEvents: paypalDisabled ? 'none' : '', opacity: paypalDisabled ? 0.6 : 1, cursor: paypalDisabled ? 'not-allowed' : 'pointer' }"
                                 @click="!paypalDisabled && PaymentMethodClick(5)">
                                <img src="../../../../assets/img/recharge/paypal.png" style="width: 70px;" alt="">
                                <div class="rightContent">
                                    <div class="weixinHeard">
                                        <span style="font-size: 16px;">Pay pal</span>
                                        <span class="paybaseShow" :class="{ payChoose: PaymentMethod == 5 }"></span>
                                    </div>
                                    <div class="weixinPayTip">
                                        {{ $t('recharge.Recharge_tip4') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label=" " size="small">
                        <div class="rechMoney packageTip">
                            <div style="font-size: 16px;display: flex;align-items: center;"><span>{{$t('collectionFrequencyUP.Online_payment')}}</span>
                                <!-- <i @click="goPurchaseTerms" class="iconfont icon-bangzhu questionMark"></i> -->
                                <img @click="goPurchaseTerms" class="questionMark" src="../../../../assets/img/general/Subtract.png" alt=""></div>
                            <div>{{ $t('recharge.rechMoney') }}
                                <span class="active">&nbsp;{{currencySymbol}}{{rechargingInfo&&rechargingInfo.package?rechargingInfo.package.price:'--'}}</span>
                                <!-- <span v-if="PaymentMethod ==5">{{`（${$t('collectionFrequencyUP.paypalTip')}）`}}</span> -->
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="rechargeCon">
                    <el-button type="button" class="elbtn operation" :class="{ 'operation1': rechargeButtonDisabled }" :disabled="rechargeButtonDisabled" @click="confirmRecharge">{{$t('collectionFrequencyUP.Recharge_now')}}</el-button>
                </div>
                <div class="termAll">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <span class="termRed">{{$t('collectionFrequencyUP.have_read')}}</span>
                    <span class="term" @click="goRechargeTerms">{{`《${$t('collectionFrequencyUP.Collection_terms')}》`}}</span>
                </div>
            </div>
        </div>
        <!-- 购买条款 -->
        <recharge-dialog :title="$t('collectionFrequencyUP.Purchase_Terms')" :visible.sync="purchaseTermsDialog" :class="{
            showDialog: purchaseTermsDialog,
            hideDialog: !purchaseTermsDialog,
        }" width="600px" noFooter>
            <div slot="content">
                <div class="termItem">
                    <p class="active">Q:<span>{{`${$t('collectionFrequencyUP.Purchase_Terms1')}？`}}</span></p>
                    <p>A:<span>{{$t('collectionFrequencyUP.Purchase_Terms2')}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active">Q:<span>{{`${$t('collectionFrequencyUP.Purchase_Terms3')}？`}}</span></p>
                    <p>A:<span>{{$t('collectionFrequencyUP.Purchase_Terms4')}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active">Q:<span>{{`${$t('collectionFrequencyUP.Purchase_Terms5')}？`}}</span></p>
                    <p>A:<span>{{$t('collectionFrequencyUP.Purchase_Terms6')}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active">Q:<span>{{`${$t('collectionFrequencyUP.Purchase_Terms7')}？`}}</span></p>
                    <p>A:<span>{{$t('collectionFrequencyUP.Purchase_Terms8')}}</span></p>
                </div>

                <div class="termFootButton">
                    <el-button type="button" class="elbtn btn-dark" @click="purchaseTermsDialog = false">
                    {{ $t("datalogger.confirm") }}
                    </el-button>
                </div>
            </div>
        </recharge-dialog>
        <!-- 充值条款 -->
        <recharge-dialog :title="$t('collectionFrequencyUP.Collect_terms')" :visible.sync="rechargeTermsDialog" :class="{
            showDialog: rechargeTermsDialog,
            hideDialog: !rechargeTermsDialog,
        }" width="600px" noFooter>
            <div slot="content">
                <p style="font-size: 16px;">{{$t('collectionFrequencyUP.Collect_terms1')}}</p>
                <div class="termItem">
                    <p class="active"><span>{{`${$t('collectionFrequencyUP.Collect_terms2')}`}}</span></p>
                    <p><span>{{`${$t('collectionFrequencyUP.Collect_terms3')}`}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active"><span>{{`${$t('collectionFrequencyUP.Collect_terms4')}`}}</span></p>
                    <p><span>{{`${$t('collectionFrequencyUP.Collect_terms5')}`}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active"><span>{{`${$t('collectionFrequencyUP.Collect_terms6')}`}}</span></p>
                    <p><span>{{`${$t('collectionFrequencyUP.Collect_terms7')}`}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active"><span>{{`${$t('collectionFrequencyUP.Collect_terms8')}`}}</span></p>
                    <p><span>{{`${$t('collectionFrequencyUP.Collect_terms9')}`}}</span></p>
                </div>
                <div class="termItem">
                    <p class="active"><span>{{`${$t('collectionFrequencyUP.Collect_terms10')}`}}</span></p>
                    <p><span>{{`${$t('collectionFrequencyUP.Collect_terms11')}`}}</span></p>
                </div>
                <div class="termFootButton">
                    <el-button type="button" class="elbtn btn-dark" @click="checked = true; rechargeTermsDialog = false">
                        {{ $t("datalogger.confirm") }}
                    </el-button>
                </div>
            </div>
        </recharge-dialog>
        <!-- 充值二维码 -->
        <recharge-dialog :title="$t('collectionFrequencyUP.Scan_payment')" :visible.sync="qrCodeDialog" :class="{
            showDialog: qrCodeDialog,
            hideDialog: !qrCodeDialog,
        }" width="600px" noFooter>
            <div slot="content" class="stepQrCode">
                <p class="price">{{currencySymbol}}{{rechargingInfo&&rechargingInfo.package?rechargingInfo.package.price:'--'}}</p>
                <div class="qr" ref="qr"></div>
                <p class="info" v-if="PaymentMethod == 0">{{ $t('recharge.openWx') }}</p>
                <div  v-else style="text-align: center;">
                    <p class="info">{{ $t('recharge.scanComplete') }}</p>
                    <p>{{`（${$t('collectionFrequencyUP.paypalTip')}）`}}</p>
                </div>
            </div>
        </recharge-dialog>
        <!-- 充值结果-成功 -->
        <recharge-dialog :title="$t('collectionFrequencyUP.Recharge_result')" :visible.sync="rechargeSucResultDialog" :class="{
            showDialog: rechargeSucResultDialog,
            hideDialog: !rechargeSucResultDialog,
        }" width="600px" noFooter>
            <div slot="content" class="rechargeSucResult">
                <img src="../../../../assets/img/recharge/collectionFrequencySuc.png" class="qr" alt="">
                <p class="item" style="font-size: 18px;">{{$t('collectionFrequencyUP.Recharge_successful')}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Recharge_successful_next')}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Order_No')}}:{{orderResultInfo.orderno}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Recharge_time')}}:{{orderResultInfo.payTime}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Recharge_amount')}}:<span class="active">{{currencySymbol}}{{orderResultInfo.amount}}</span></p>
                <div class="rechargeResultButton">
                    <el-button type="button" class="elbtn btn-dark" @click="toViewOrder()">
                        {{$t('collectionFrequencyUP.view_order')}}
                    </el-button>
                </div>
            </div>
        </recharge-dialog>
        <!-- 充值结果-失败 -->
        <recharge-dialog :title="$t('collectionFrequencyUP.Recharge_result')" :visible.sync="rechargeErrResultDialog" :class="{
            showDialog: rechargeErrResultDialog,
            hideDialog: !rechargeErrResultDialog,
        }" width="600px" noFooter>
            <div slot="content" class="rechargeSucResult">
                <img src="../../../../assets/img/recharge/collectionFrequencyFail.png" class="qr" alt="">
                <p class="item" style="font-size: 18px;">{{$t('collectionFrequencyUP.Recharge_failed')}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Recharge_failed_next')}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Order_No')}}:{{orderResultInfo.orderno}}</p>
                <p class="item">{{$t('collectionFrequencyUP.Recharge_amount')}}:<span class="active">{{currencySymbol}}{{orderResultInfo.amount}}</span></p>
                <div class="rechargeResultButton">
                    <el-button type="button" class="elbtn btn-dark"  @click="toViewOrder()">
                        {{$t('collectionFrequencyUP.view_order')}}
                    </el-button>
                </div>
            </div>
        </recharge-dialog>
        <!-- 充值二次确认弹窗 -->
        <recharge-dialog :title="$t('collectionFrequencyUP.paySecCon')" :visible.sync="rechargeSeconDialog" :class="{
            showDialog: rechargeSeconDialog,
            hideDialog: !rechargeSeconDialog,
        }" width="1000px" noFooter>
            <div slot="content" class="rechargeSucResult">
                <div class="rechargeSecondTip" v-if="collectionUPPage==1">{{$t('collectionFrequencyUP.energyFetchPic')}}:</div>
                <div class="rechargeSecondTip" v-else>{{$t('collectionFrequencyUP.historyFetchPic')}}:</div>
                <img src="../../../../assets/img/recharge/dataDetailExample.png" v-if="collectionUPPage==2&& $lang.currentLang=='zh_CN'" class="examplePic"   alt="">
                <img src="../../../../assets/img/recharge/dataDetailExampleUs.png" v-else-if="collectionUPPage==2&& $lang.currentLang !='zh_CN'"  class="examplePic"  alt="">
                <img src="../../../../assets/img/recharge/energyFetchExample.png" v-else-if="collectionUPPage==1&& $lang.currentLang=='zh_CN'"  class="examplePic"  alt="">
                <img src="../../../../assets/img/recharge/energyFetchExampleUs.png" v-else-if="collectionUPPage==1&& $lang.currentLang !='zh_CN'"  class="examplePic"  alt="">
                <div class="rechargeResultButton between">
                    <el-button type="button" class="elbtn btn-dark btnSe" style="background: #22534d;"  @click="rechargeSeconDialog=false">
                        {{$t('device.cancel')}}
                    </el-button>
                    <el-button type="button" class="elbtn btn-dark btnSe"  @click="subRechargeButton()">
                        {{$t('device.confirm')}}
                    </el-button>
                </div>
            </div>
        </recharge-dialog>
        <!-- 续充二次确认弹窗 -->
        <recharge-dialog :title="$t('recharge.Tips')" :visible.sync="Recharge" :class="{
            showDialog: Recharge,
            hideDialog: !Recharge,
        }" width="400px" noFooter>
            <div slot="content" class="rechargeSucResult recharge-tip">
                <div class="rechargeSecondTip" v-if="collectionUPPage==1">{{$t('collectionFrequencyUP.reRechargeTip1')}}</div>
                <div class="rechargeSecondTip" v-else>{{$t('collectionFrequencyUP.reRechargeTip')}}</div>
                <div class="rechargeResultButton between">
                    <el-button type="button" class="elbtn btn-dark btnSe" style="background: #22534d;"  @click="Recharge=false">
                        {{$t('device.cancel')}}
                    </el-button>
                    <el-button type="button" class="elbtn btn-dark btnSe"  @click="Recharge=false;rechargeSeconDialog=true">
                        {{$t('collectionFrequencyUP.continueRecharge')}}
                    </el-button>
                </div>
            </div>
        </recharge-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import rechargeDialog from "@/components/dialognew";
import QRCode from "qrcodejs2";
import { Loading } from 'element-ui';
export default {
    components: {
        rechargeDialog,
    },
    props: {
    // 频率加速页面 1能流2明细
    collectionUPPage: {
       default: 2
     },
    // 设备通信类型
    gprsType: {
        type: String,
        default: ''
     },
    // 采集充值标志对象
    rechargeFlagObj: {
        type: Object,
        default: null
     },
    },
    data() {
        return {
            rechargeSeconDialog: false,//二次确认弹窗
            Recharge: false,//续充二次确认弹窗
            collectionUpDisplayVal:false,//能流tab显示与否
            // fieldList: 20,
            frequencyUPLoading:false,
            orderResultInfo:'',
            PaymentMethod: 0,
            checked: false,
            rechargeTermsDialog: false,
            purchaseTermsDialog: false,
            qrCodeDialog: false,
            rechargeSucResultDialog: false,
            rechargeErrResultDialog: false,
            availablePackages: [],
            rechargingInfo: null,
            rechargePriceInfo: '',
            // 充值时长
            durationOptions: [],
            selectedDuration: '',
            // 标志位：true表示程序赋值（不触发watch），false表示用户操作（触发watch）
            isProgrammaticChange: false,
            // 当前已生效套餐周期 能流0表示未购买过s，数据明细5表示未购买过min
            currentEnergyFetch: 0,
            // 当前已购买时长，0表示未购买过
            purchasedTime: 0,
            // 轮询扫码结果
            orderResultPolling: null,
            paypalDisabled: false, //pay禁用
            wechatDisabled: false, //wechat禁用
            // 初始化标志位，用于避免 created 中赋值触发 watch
            isInitializing: false,
        }
    },
    computed: {
        ...mapGetters({
            deviceInfo: 'getDeviceInfo',
        }),
        currencySymbol() {
          return this.PaymentMethod == 5 ? '$' : '￥';
        },
        rechargeButtonDisabled() {
          // 未选择套餐 或 未选择时长 或 无价格 或 未勾选协议
          if (!this.rechargingInfo || !this.rechargingInfo.package) return true;
          if (!this.selectedDuration) return true;
          if (!this.rechargingInfo.package.price || this.rechargingInfo.package.price == 0) return true;
          if (!this.checked) return true;
          return false;
        },
    },
    watch: {
     qrCodeDialog(val) {
       if (!val) {
         clearInterval(this.orderResultPolling);
         this.orderResultPolling = null;
         var qrcodeElement = this.$refs.qr;
         while (qrcodeElement.firstChild) {
           qrcodeElement.removeChild(qrcodeElement.firstChild);
         }
        //  if (this.checked&&this.rechargePriceInfo&&this.rechargePriceInfo.amount) {
        //   this.rechargeButtonDisabled = false;
        //  }else{
        //   this.rechargeButtonDisabled = true;
        //  }
       }
     },
     checked(val) {
     },
     selectedDuration(newVal, oldVal) {
       // 如果是程序赋值（如 initDurationOptions），不触发 watch
       if (this.isProgrammaticChange) return;
       // 只有用户点击选择才触发
       if (newVal && newVal !== oldVal) {
         this.fetchTariffByPage();
         console.log('selectedDuration changed:', newVal, oldVal)
       }
     },
  },
    created() {
        // 设置程序赋值标志位
        this.isProgrammaticChange = true;
        this.initDurationOptions();
        // 重置标志位
        this.$nextTick(() => {
          this.isProgrammaticChange = false;
        });
        // 根据页面类型调用对应套餐接口
        if (this.collectionUPPage === 2) {
          this.currentEnergyFetch = 5
          this.getROSTariffPackage(true)
        } else if (this.collectionUPPage === 1) {
          this.currentEnergyFetch = 0
          // 先调用 getRechargePayMode，无论成功失败都继续调用 getROSEnergyTariffPackage
          this.getRechargePayMode()
            .finally(() => {
              this.getROSEnergyTariffPackage(true);
            });
        }
        // // 能流tab显示时才查询能流字段
        // if (this.rechargeFlagObj && this.rechargeFlagObj.energyFlowEnabled) {
        //   this.queryFields()
        // }
    },
    mounted() {
        // this.collectionDataAll()//判断是否显示能流tab
        // console.log(this.collectionUPPage,"collectionUPPagecollectionUPPagecollectionUPPage")
    },
    methods: {
        // 判断套餐是否禁用：仅能流(collectionUPPage===1)时，已购买过套餐不能选择比当前周期更大的
        isPackageDisabled(item) {
          if (this.collectionUPPage === 2) return false;
          if (!this.currentEnergyFetch || this.currentEnergyFetch === 0) return false;
        //   return item.periodSeconds >= this.currentEnergyFetch;
          return item.periodSeconds > this.currentEnergyFetch;
        },
        // 判断时长是否禁用：仅能流(collectionUPPage===1)时，已购买过时长不能选择比当前时长更小的
        isDurationDisabled(item) {
          if (this.collectionUPPage === 2) return false;
          if (!this.purchasedTime || this.purchasedTime === 0) return false;
          let compareValue = this.gprsType === 'WIFI' ? item.value * 12 : item.value;
          return compareValue < this.purchasedTime;
        },
        // 根据collectionUPPage调用对应套餐接口
        fetchTariffByPage() {
          if (this.collectionUPPage === 2) {
            this.getROSTariffPackage();
          } else if (this.collectionUPPage === 1) {
            this.getROSEnergyTariffPackage();
          }
        },
        // 获取充值支付方式配置
        getRechargePayMode() {
            return this.$request.getDEVMicroservices('/ros/api/rechargeOrder/pub/getRechargePayModeByPn', {
                pn: this.deviceInfo.pn,
                rechargeType: 1
            }).then(res => {
                if (res.code === 0 && res.data) {
                    const payModeVal = res.data.channel;
                    // 如果为 null，则禁用 PayPal，默认选中微信
                    if (payModeVal === null || payModeVal === undefined) {
                        this.paypalDisabled = false;
                        this.wechatDisabled = false;
                        this.PaymentMethod = 0;
                    } 
                    // 如果为 5，则禁用微信，默认选中 PayPal
                    else if (payModeVal === 5) {
                        this.paypalDisabled = false;
                        this.wechatDisabled = true;
                        this.PaymentMethod = 5;
                    } 
                    // 其他情况，都不禁用
                    else {
                        this.paypalDisabled = true;
                        this.wechatDisabled = false;
                        this.PaymentMethod = 0;
                    }
                }else{
                    this.paypalDisabled = false;
                    this.wechatDisabled = false;
                    this.PaymentMethod = 0;
                }
            }).catch(err => {
                console.error('获取支付方式配置失败:', err);
                // 失败时默认都不禁用
                this.paypalDisabled = false;
                this.wechatDisabled = false;
                this.PaymentMethod = 0;
            });
        },
        // 数据明细套餐和价格信息获取
        getROSTariffPackage(isInit) {
            this.frequencyUPLoading = true
            let param = {
              pn: this.deviceInfo.pn,
              devcode: this.deviceInfo.devcode,
              payWay: this.PaymentMethod,
              years: this.selectedDuration || 1,
            }
            this.$request.getDEVMicroservices(`/ros/api/recharge/tariff/queryDisHistoryDataTariff`,param).then(res => {
                this.frequencyUPLoading = false
                if (res.code == 0) {
                    let data = res.data;
                    // 记录当前已生效套餐信息，用于限制可选范围
                    this.currentEnergyFetch = data.currentEnergyFetch || 5;
                    // this.purchasedTime = data.purchasedTime || 0;
                    this.availablePackages = [data];
                    let currentPeriodSeconds = !isInit && this.rechargingInfo && this.rechargingInfo.package && this.rechargingInfo.package.periodSeconds;
                    let matched = currentPeriodSeconds && this.availablePackages.find(item => item.periodSeconds == currentPeriodSeconds);
                    this.rechargingInfo = {
                      ...data,
                      package: matched || data
                    };
                  } else {
                    this.$message.error(res.message);
                  }
          });
        },
        // 能流套餐和价格信息获取
        getROSEnergyTariffPackage(isInit){
            this.frequencyUPLoading = true
            let param = {
              devcode: this.deviceInfo.devcode,
              pn: this.deviceInfo.pn,
              payWay: this.PaymentMethod,
            }
            if (this.gprsType === 'WIFI') {
              param.years = this.selectedDuration;
            } else {
              param.days = this.selectedDuration;
            }
            this.$request.getDEVMicroservices(`/ros/api/recharge/tariff/queryDisRechargeTariffPackage`,param).then(res => {
                this.frequencyUPLoading = false
                if (res.code == 0) {
                    let data = res.data;
                    // 记录当前已生效套餐信息，用于限制可选范围
                    this.currentEnergyFetch = data.currentEnergyFetch || 0;
                    this.purchasedTime = data.purchasedTime || 0;
                    // 如果已购买过时长，修正默认选中为第一个可选时长
                    if (isInit && this.purchasedTime > 0 && this.collectionUPPage === 1) {
                      let validOption = this.durationOptions.find(item => {
                        let compareValue = this.gprsType === 'WIFI' ? item.value * 12 : item.value;
                        return compareValue >= this.purchasedTime;
                      });
                      if (validOption) {
                        this.selectedDuration = validOption.value;
                      } else {
                        this.selectedDuration = '';
                      }
                    }
                    this.availablePackages = data.tariffList || [];
                    //  this.availablePackages.length 为真（数组不为空）
                    //    且 this.availablePackages.find(...) 找到匹配项
                    //   返回 this.availablePackages[0]（第一个元素）
                    let firstPackage = this.currentEnergyFetch == 0 && this.availablePackages.length ? this.availablePackages[0] : (this.availablePackages.length && this.availablePackages.find(item => item.periodSeconds == this.currentEnergyFetch) ? this.availablePackages[0] : null);
                    let currentPeriodSeconds = !isInit && this.rechargingInfo && this.rechargingInfo.package && this.rechargingInfo.package.periodSeconds;
                    let matched = currentPeriodSeconds && this.availablePackages.find(item => item.periodSeconds == currentPeriodSeconds);
                    this.rechargingInfo = {
                      ...data,
                    //   package: (this.collectionUPPage == 1 && this.currentEnergyFetch == 5) ? null : (matched || firstPackage)
                      package: matched || firstPackage
                    };
                  } else {
                    this.$message.error(res.message);
                  }
          });
        },
        // 根据通信类型初始化充值时长选项
        initDurationOptions(page) {
          let currentPage = page || this.collectionUPPage;
          if (currentPage === 2) {
            // 数据明细：固定1年选项，不区分gprsType
            this.durationOptions = [
              { label: `1${this.$t('rosRecharge.year')}`, value: 1 }
            ];
            this.selectedDuration = 1;
          } else if (this.gprsType === 'WIFI') {
            this.durationOptions = [
              { label: `1${this.$t('rosRecharge.year')}`, value: 1 },
            //   { label: '3年', value: 3 },
              { label: `5${this.$t('rosRecharge.year')}`, value: 5 }
            ];
            this.selectedDuration = 1;
          } else {
            // 4G
            this.durationOptions = [
              { label: `1${this.$t('rosRecharge.days')}`, value: 1 },
              { label: `7${this.$t('rosRecharge.days')}`, value: 7 }
            ];
            this.selectedDuration = 7;
          }
        },
        // collectionDataAll () {
        //   this.frequencyUPLoading = true;
        //   this.collectionData().then(result => {
        //     result && this.queryFields()
        //   })
        // },
    //    collectionData(){
    //     this.frequencyUPLoading = true
    //      return this.$request
    //         .get("queryRechargeEnergyFlag", {
    //           devcode: this.deviceInfo.devcode,
    //           i18n: this.$lang.currentLang
    //         })
    //         .then(res => {
    //             this.frequencyUPLoading = false
    //           if (res.err == 0) {
    //             this.collectionUpDisplayVal = true
    //             return true
    //           }else {
    //             this.collectionUpDisplayVal = false
    //             return false
    //           }
    //         }).catch(e => {
    //           this.collectionUpDisplayVal = false
    //           this.frequencyUPLoading = false
    //           return false
    //       });
    //     },
    //    queryFields () {
    //     let param = {
    //       devcode: this.deviceInfo.devcode,
    //       i18n: this.$lang.currentLang
    //     }
    //     this.frequencyUPLoading = true
    //     this.$request.get('queryDeviceChartsFieldsEs', param).then(res => {
    //       this.isLoading = false;
    //       if (res.err === 0) {
    //         this.fieldList = res.dat.length
    //       } else {
    //         this.fieldList = 20
    //       }
    //       this.frequencyUPLoading = false
    //     }).catch(e => {
    //         this.frequencyUPLoading = false
    //         this.fieldList = 20
    //     });
    //   },
       switchTab(val) {
        if (this.collectionUPPage === val)  return
          this.rechargingInfo = null;
          this.availablePackages = [];
          if (val === 1) {
            this.currentEnergyFetch = 0;
          } else {
            this.currentEnergyFetch = 5;
            this.paypalDisabled = false;
            this.wechatDisabled = false;
          }
          this.purchasedTime = 0;
          this.$emit('update:collectionUPPage', val);
          // 设置程序赋值标志位，避免触发 watch
          this.isProgrammaticChange = true;
          this.initDurationOptions(val);
          // 重置标志位
          this.$nextTick(() => {
            this.isProgrammaticChange = false;
          });
          this.$nextTick(() => {
            if (val === 2) {
              this.getROSTariffPackage(true);
            } else if (val === 1) {
              // 先调用 getRechargePayMode，无论成功失败都继续调用 getROSEnergyTariffPackage
              this.getRechargePayMode()
                .finally(() => {
                  this.getROSEnergyTariffPackage(true);
                });
            }
          });
    },
        // getQueryCollRechargeTariffPackage(){
        //     this.frequencyUPLoading = true
        //     let rechargings = {
        //       pn: this.deviceInfo.pn
        //     };
        //     this.$request
        //         .get("queryCollRechargeTariffPackage", {
        //           type: this.collectionUPPage,
        //           pn: this.deviceInfo.pn,
        //           i18n: this.$lang.currentLang
        //         })
        //         .then(res => {
        //         this.frequencyUPLoading = false
        //           if (res.err == 0) {
        //             let packages = [];
        //             res.dat.forEach(item => {
        //               let arr = item.specName.split("/");
        //               packages.push({
        //                 label: arr[0],
        //                 duration: arr[1],
        //                 specName: item.specName,
        //                 id: item.id,
        //                 specCoefficient: item.specCoefficient,
        //                 specValue: item.specValue,
        //                 type: item.type,
        //               });
        //             });
        //             this.availablePackages = packages;
        //             // rechargings.package = null;
        //             rechargings.package = packages.length && packages[0];
        //             this.rechargingInfo = rechargings;
        //             this.getCollRechargePrice()
        //           }else {
        //             this.$message.error(this.$t(`errCode.${res.err}`));
        //           }
        //         }).catch(e => {
        //         this.frequencyUPLoading = false
        //     });
        // },
        // getCollRechargePrice(){
        //     this.frequencyUPLoading = true
        //     this.$request
        //         .get("queryCollRechargePrice", {
        //           rechargeType: this.rechargingInfo.package.type,
        //           pn: this.deviceInfo.pn,
        //           historyTariff: this.collectionUPPage==2?this.rechargingInfo.package.specValue:'',
        //           i18n: this.$lang.currentLang,
        //           powerTariff: this.collectionUPPage==1?this.rechargingInfo.package.specValue:'',
        //           powerNumber: 20,
        //         })
        //         .then(res => {
        //           if (res.err == 0) {
        //             if(this.checked)
        //             this.rechargeButtonDisabled = false;
        //             this.rechargePriceInfo = res.dat
        //           }else {
        //             this.rechargeButtonDisabled = true;
        //             this.rechargePriceInfo = ''
        //             // this.$message.error(this.$t(`errCode.${res.err}`));
        //         }
        //         this.frequencyUPLoading = false
        //     }).catch(e => {
        //         this.frequencyUPLoading = false
        //     });
        // },
        //后退
        clickClosepage() {
            this.$store.commit('saveIsShow', 1);
            this.$store.state.event.foldGeneralSidebarNew = true;
        },
        PaymentMethodClick(val) {
            if(this.PaymentMethod == val) return false
            this.PaymentMethod = val
            this.fetchTariffByPage()
        },
        // 购买条款
        goPurchaseTerms() {
            this.purchaseTermsDialog = true
        },
        // 充值条款
        goRechargeTerms() {
            this.rechargeTermsDialog = true
        },
        // 充值二次确认弹框打开
        confirmRecharge() {
            this.rechargePriceInfo = {
              ...this.rechargingInfo,
              ...this.rechargingInfo.package
            }
            // 能流充值且已购买过时长，或数据明细加速且已购买过套餐，先弹续充提醒，点击继续后再弹支付确认弹窗
            if ((this.collectionUPPage === 1 && this.rechargePriceInfo.purchasedTime > 0)
              || (this.collectionUPPage === 2 && this.rechargePriceInfo.currentEnergyFetch != 5)) {
              this.Recharge = true
            } else {
              this.rechargeSeconDialog = true
            }
            console.log(this.rechargePriceInfo)
        },
        // 充值确认提交
        subRechargeButton() {
            this.rechargeSeconDialog = false
            // this.frequencyUPLoading = true
            // this.$request
            //     .get("collRechargeQrCode", {
            //     //   amount: 0.01,
            //       amount: this.rechargePriceInfo.amount,
            //       load:this.rechargePriceInfo.load,
            //       rechargeType: this.rechargePriceInfo.rechargeType,
            //       pn: this.deviceInfo.pn,
            //       channel:this.PaymentMethod,
            //       frequency:this.rechargePriceInfo.frequency,
            //       parmerNumber:this.rechargePriceInfo.parmerNumber,
            //       orderType:this.rechargePriceInfo.orderType,
            //       i18n: this.$lang.currentLang,
            //     })
            //     .then(res => {
            //       if (res.err == 0) {
            //         this.qrCodeDialog = true
            //         this.$nextTick(() => {
            //          // 生成二维码图片
            //          new QRCode(this.$refs.qr, {
            //            text: res.dat.url, // 二维码url
            //            width: 180,
            //            height: 180
            //          });
            //          // 轮询扫码结果
            //          this.orderResultPolling && clearInterval(this.orderResultPolling);
            //          this.orderResultPolling = setInterval(() => {
            //            this.$request
            //              .get("queryCollRechargeOrderStatus", {
            //                orderno: res.dat.orderno,
            //                pn: this.deviceInfo.pn,
            //                timezone: -(new Date().getTimezoneOffset() / 60),
            //              })
            //              .then(res => {
            //                if (res.err === 0 && res.dat.collector[0].status !== 0) {
            //                  this.collectionUp();
            //                  this.qrCodeDialog = false;
            //                  this.orderResultInfo = res.dat.collector[0]
            //                  this.rechargeSucResultDialog = true;
            //                  var qrcodeElement = this.$refs.qr;
            //                  while (qrcodeElement.firstChild) {
            //                    qrcodeElement.removeChild(qrcodeElement.firstChild);
            //                  }
            //                }
            //              });
            //          }, 2000);
            //        });
            //       }else if(res.err == 8){
            //         this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
            //       }else if(res.err == 9){
            //         this.$message.error(this.$t('collectionFrequencyUP.noRecharg_min'));
            //       }else {
            //         this.$message.error(this.$t(`errCode.${res.err}`));
            //     }
            //     this.frequencyUPLoading = false
            // });
            let param = {
               //   amount: 0.01,
                 amount: this.rechargePriceInfo.price,
                 appId: 'app_0078983b4587',
                 channel:this.PaymentMethod,
                 pn: this.deviceInfo.pn,
               //   load:this.rechargePriceInfo.load,
                 frequency:this.rechargePriceInfo.periodSeconds,
               //   WiFi类型传月数，其他传天数
                 ...(this.collectionUPPage === 2
                   ? { packageMonths: this.rechargePriceInfo.packageMonths }
                   : (this.gprsType === 'WIFI'
                     ? { packageMonths: this.rechargePriceInfo.months }
                     : { packageDays: this.rechargePriceInfo.days })),
               //   参数个数
                 parmerNumber: this.rechargePriceInfo.parameterCount|| '20',
               //   充值类型：1-实时参数加速 2-历史数据加速
                 rechargeType: this.collectionUPPage,
                 // 订单类型：0-普通订单，1-补充值订单
                 orderType: this.collectionUPPage === 1
                   ? (this.rechargePriceInfo.currentEnergyFetch !== 0 ? '1' : '0')
                   : (this.rechargePriceInfo.currentEnergyFetch !== 5 ? '1' : '0'),
                 // 设备类型：WIFI、4G
                 deviceType: this.rechargePriceInfo.deviceType,
               //   1-年费，2-日费, 3-月费
                 priceType: this.rechargePriceInfo.priceType,
                 systemType: '1',
                 payScene: '0',
            }
            this.frequencyUPLoading = true
            this.$request
                .postDEVMicroservices(`/ros/api/rechargeOrder/collDisRechargeOrder`, param)
                .then(res => {
                  if (res.code == 0) {
                    this.qrCodeDialog = true
                    this.$nextTick(() => {
                     // 生成二维码图片
                     new QRCode(this.$refs.qr, {
                       text: res.data.url, // 二维码url
                       width: 180,
                       height: 180
                     });
                     // 轮询扫码结果
                     this.orderResultPolling && clearInterval(this.orderResultPolling);
                     this.orderResultPolling = setInterval(() => {
                       this.$request
                         .getDEVMicroservices("/ros/api/rechargeOrder/pub/queryRechargeOrderDetails", {
                           orderno: res.data.orderno,
                        //    pn: this.deviceInfo.pn,
                        //    timezone: -(new Date().getTimezoneOffset() / 60),
                         })
                         .then(ress => {
                            console.log(res);
                           if (ress.code === 0 && ress.data.status == 2) {
                            // 刷新当前tab数据
                             this.collectionUp();
                             this.qrCodeDialog = false;
                             this.orderResultInfo = ress.data
                             this.rechargeSucResultDialog = true;
                             var qrcodeElement = this.$refs.qr;
                             while (qrcodeElement.firstChild) {
                               qrcodeElement.removeChild(qrcodeElement.firstChild);
                             }
                           }
                         });
                     }, 2000);
                   });
                  }
                //   else if(res.err == 8){
                //     this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
                //   }else if(res.err == 9){
                //     this.$message.error(this.$t('collectionFrequencyUP.noRecharg_min'));
                //   }
                  else {
                    // this.$message.error(this.$t(`errCode.${res.err}`));
                    this.$message.error(res.message);
                }
                this.frequencyUPLoading = false
            });
        },
        // 充值成功调用，套餐信息
       collectionUp(){
          this.rechargingInfo = null;
          this.rechargePriceInfo = null;
          this.availablePackages = [];
          if (this.collectionUPPage === 1) {
            this.currentEnergyFetch = 0;
          } else {
            this.currentEnergyFetch = 5;
          }
          this.purchasedTime = 0;
          // 设置程序赋值标志位，避免触发 watch
          this.isProgrammaticChange = true;
          this.initDurationOptions();
          // 重置标志位
          this.$nextTick(() => {
            this.isProgrammaticChange = false;
          });
        if (this.collectionUPPage === 2) {
          this.getROSTariffPackage(true)
        } else if (this.collectionUPPage === 1) {
          // 先调用 getRechargePayMode，无论成功失败都继续调用 getROSEnergyTariffPackage
          this.getRechargePayMode()
            .finally(() => {
              this.getROSEnergyTariffPackage(true);
            });
        }
      },
        toViewOrder(){
            this.$router.push({ path: "/generalNew/setting/collectionFrequencyRecord" });
        },
    }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.collectionFrequencyUP {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;

    // 统一按钮系列
    .btn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
    }
    .operation{
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
      }

      .operation1{
        background: @primaryColorTransparency30;
        color: rgba(34, 45, 53, 1);
        border: none;
      }

    .elbtn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        line-height: normal
    }

    .btn-disable {
        color: rgba(242, 242, 242, 0.5);
        background: rgba(43, 56, 66, 1);
        cursor: not-allowed;
    }

    .btn-dark {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
    }

    .btn-light {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
    }

    .upgradeInfo {
        height: 60px !important;
        margin-bottom: 12px;
        box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.1);
        display: flex;
        height: 100%;

        .closepage {
            background-color: rgba(255, 255, 255, 0.05);
            width: 63px;
            height: 60px;
            background-image: url('../../../../assets/img/general/arrow_left.png');
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
            cursor: pointer;
        }

        .xinxi {
            width: 100%;
            height: 60px;
            color: #fff;
            background-color: #222D35;
            font-size: 16px;

            .top-info {
                margin-left: 20px;
                line-height: 60px;
            }
        }
    }

    .infobox {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex: 1;
        color: #fff;
        background-color: #222D35;

        .content {
            display: flex;
            flex-direction: column;
            flex: 1;
            padding: 20px 20% 0 15%;
            .tab-bar {
  display: flex;
      margin-bottom: 50px;
    justify-content: center;
    border-bottom: 2px solid #444;
    margin-left: 80px;
}
.tab-item {
  padding: 8px 24px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #999;
  font-size: 16px;
  margin-right: 24px;
  transition: color 0.2s, border-color 0.2s;
}
.tab-item.active {
  color: var(--primaryTextColor, #30D096);
  border-bottom: 2px solid var(--primaryTextColor, #30D096);
  font-weight: bold;
}
            .storageTips{
                color: var(--primaryTextColor, #30D096);
            }
            .paymentMethodItem {
                display: flex;
                align-items: center;
                cursor: pointer;

                .rightContent {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    height: 70px;
                    margin-left: 30px;

                    .weixinHeard {
                        height: 30px;
                        display: flex;
                        align-items: center;
                    }
                }
            }

            .paybaseShow {
                width: 24px;
                height: 24px;
                box-sizing: border-box;
                display: inline-block;
                background-repeat: no-repeat;
                background-position: 50%;
                border-radius: 50%;
                border: 2px solid #333333;
                ;
                background-color: rgba(26, 92, 107, 1);
                margin-left: 20px;
            }

            .weixinPayTip {
                font-size: 14px;
                margin-top: 10px;
                text-align: left;
                color: rgba(255, 255, 255, 0.556862745098039);
                line-height: 1.6;
            }

            .payChoose {
                border: 2px solid #333333;
                ;
                background-color: rgba(26, 92, 107, 1);
                background-image: url(../../../../assets/img/recharge/check.png);
                background-size: 14px 14px;
            }

            .package {
                display: inline-block;
                padding: 7px 0;
                width: 110px;
                border-radius: 6px;
                text-align: center;
                border: none;
                cursor: pointer;
                background: rgba(43, 56, 66, 1);
                color: rgb(123, 131, 149);
                font-size: 16px;
                margin: 0 10px 10px 0;
                position: relative;
                &:hover {
                    color: @primaryTextColor;
                }

                &.selected {
                    color: @primaryTextColor;
                }
                .line{
                    border: 1px solid #939597;
                    width: 100%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%);
                }
            }

            .packageTip {
                background-color: rgba(255, 255, 255, 0.05);
                border-radius: 6px;
                padding: 5px 15px;
                .questionMark{
                    cursor: pointer;
                    margin-left: 5px;
                }
            }

            .rechargeCon {
                text-align: center;
                margin-left: 200px;
                margin-top: 80px;
            }

            .termAll {
                text-align: center;
                margin-left: 200px;
                margin-top: 20px;

                .termRed {
                    margin-left: 5px;
                }

                .term {
                    color: @primaryTextColor;
                    cursor: pointer;
                }
            }

            /deep/.el-checkbox {

                .el-checkbox__input .el-checkbox__inner {
                    width: 16px;
                    height: 16px;
                    background-color: #FFF;
                    border: 1px solid #d9d9d9;
                    border-radius: 2px;

                    &:hover,
                    &:focus {
                        border: 1px solid @primaryTextColor;
                    }

                    &::after {
                        top: 2px;
                        left: 5px;
                    }
                }

                .el-checkbox__input.is-checked .el-checkbox__inner {
                    background: @primaryTextColor;
                    border-color: @primaryTextColor;
                }

                .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                    background: @primaryTextColor;
                }
            }

            /deep/.el-form-item__label {
                color: #fff;
            }
        }
    }

    .active {
        color: var(--primaryTextColor, #30D096);
    }

    .termItem:nth-child(n+2) {
        margin-top: 20px;
    }

    .termFootButton {
        text-align: center;
        margin-top: 10px;
    }

    .stepQrCode {
        display: flex;
        flex-direction: column;
        align-items: center;

        .price {
            .sc(26px, rgba(51, 255, 182, 1));
            line-height: 1.6;
        }

        .qr {
            width: 180px;
            height: 180px;
            margin: 10px 0 15px;
        }

        .info {
            .sc(16px, rgba(51, 255, 182, 1));
            line-height: 1.4;
        }
    }

    .rechargeSucResult {
        display: flex;
        flex-direction: column;
        align-items: center;

        .item {
            margin-top: 10px;
        }

        .rechargeResultButton {
            text-align: center;
            margin-top: 20px;
        }
        .rechargeSecondTip{
            width: 100%;
            margin-bottom: 20px;
            font-size: 18px;
        }
        .examplePic{
            width: 100%; 
            height: 400px; 
            border: 2px solid #000; 
            border-radius: 6px;
        }
        .between{
            width: 60%;
            display: flex;
            justify-content: space-between;
        }
        .btnSe{
            color: #fff;
            padding: 6px 40px;
        }


    }
    // 续充提醒小弹窗（400px）：按钮行居中，避免窄弹窗下按钮溢出
    .recharge-tip {
        .rechargeResultButton.between {
            width: auto;
            justify-content: center;
        }

        .btnSe {
            padding: 6px 20px;
        }

        .btnSe + .btnSe {
            margin-left: 20px;
        }
    }
    /deep/.el-loading-mask{
        background-color: transparent !important;
    }
}
</style>